<div class="row">
  <div class="col-md-6">
    <!--button *ngIf="!mobiledevice && !edit && can_edit_member_offices" class="btn btn-border"
      style="margin-bottom: 10px;" (click)="addOffice()" title="Lägg till">Lägg till</button-->
  </div>
  <div class="col-md-6">
    <label class="form-check-label">
      <mat-checkbox (change)="showall = !showall" [ngClass]="(mobiledevice) ? 'pull-left':'pull-right'"
        checked="showall">Nuvarande</mat-checkbox>
    </label>
  </div>
</div>
<table class="table table-bordered" style="min-width: 500px;width:100%;">
  <thead role="rowgroup">
    <tr>
      <th>Uppdrag</th>
      <th>Period</th>
      <th></th>
    </tr>
  </thead>
  <tr *ngFor="let mo of memberoffices">
    <td *ngIf="!showall && (mo.toDate | date: 'yyyy-MM-dd') >= (currentDate | date: 'yyyy-MM-dd')">{{mo.officeName}} i
      {{mo.committeeName}} (
      <a [routerLink]="['/institutions/id/', mo.institutionId]"
        title="{{mo.institutionName}}">{{mo.institutionShortName}}</a>)
    </td>
    <td *ngIf="!showall && (mo.toDate | date: 'yyyy-MM-dd') >= (currentDate | date: 'yyyy-MM-dd')">{{mo.fromDate | date:
      'yyyy-MM-dd'}} -- {{mo.toDate | date: 'yyyy-MM-dd'}}</td>
    <td
      *ngIf="!showall && mo.currentUserCanEdit && (mo.toDate | date: 'yyyy-MM-dd') >= (currentDate | date: 'yyyy-MM-dd')"
      style="text-align: center;">
      <span *ngIf="!mobiledevice" (click)="editOffice(mo)" style="font-size:11px;color:rgb(20, 144, 185);"
        title="Ändra">Ändra</span>
      <i *ngIf="!mobiledevice" (click)="confirmRemoveOffice(mo)"
        style="margin-left:25px;color: #920000;font-weight:bold;" class="fa fa-trash" title="Ta bort"
        aria-hidden="true"></i>
    </td>
    <td
      *ngIf="!showall && !mo.currentUserCanEdit && (mo.toDate | date: 'yyyy-MM-dd') >= (currentDate | date: 'yyyy-MM-dd')">
    </td>

    <td *ngIf="showall">{{mo.officeName}} i {{mo.committeeName}} (
      <a [routerLink]="['/institutions/id/', mo.institutionId]"
        title="{{mo.institutionName}}">{{mo.institutionShortName}}</a>)
    </td>
    <td *ngIf="showall">{{mo.fromDate | date: 'yyyy-MM-dd'}} -- {{mo.toDate | date: 'yyyy-MM-dd'}}</td>
    <td *ngIf="showall && mo.currentUserCanEdit" style="text-align: center;">
      <span *ngIf="!mobiledevice" (click)="editOffice(mo)" style="font-size:11px;color:rgb(20, 144, 185);"
        title="Ändra">Ändra</span>
      <i *ngIf="!mobiledevice" (click)="confirmRemoveOffice(mo)"
        style="margin-left:25px;color: #920000;font-weight:bold;" class="fa fa-trash" title="Ta bort"
        aria-hidden="true"></i>
    </td>
    <td *ngIf="showall && !mo.currentUserCanEdit"></td>
  </tr>
</table>
<p-dialog
  header="{{editmemberoffice?.institutionShortName}} {{editmemberoffice?.institutionName}} [{{editmemberoffice?.officeName}} i {{editmemberoffice?.committeeName}}]"
  [(visible)]="edit" [modal]="true" [style]="{width: '500px'}" [baseZIndex]="10000" [draggable]="true"
  [resizable]="false" appendTo="body">
  <div *ngIf="edit" class="col-md-12">
    <p-fieldset legend="Ändra uppdrag/ämbete">
      <form [formGroup]="editform">
        <br>
        <div class="row">
          <div class="col-md-4">
            <label>Datum från</label>
            <input type="text" class="form-control form-control-sm" style="max-width:100px;" formControlName="fromDate"
            mask="0000-00-00">
          </div>
          <div class="col-md-4">
            <label>Datum till</label>
            <input type="text" class="form-control form-control-sm" style="max-width:100px;" formControlName="toDate"
            mask="0000-00-00">
          </div>
        </div>
        <br>
        <span>
          <button class="btn border" (click)="saveOffice(editform.value)">Spara</button>
          <button class="btn border" style="margin-left:20px;" (click)="cancelOffice()">Avbryt</button>
        </span>
      </form>
    </p-fieldset>
  </div>
</p-dialog>